import Box from '@mui/material/Box'
import styled from '@mui/system/styled'

export const StyledRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}))